import Axios from './axios'
import Constants from '../../constants'

export default {
  getLocationStops: () => {
    const axios = Axios.setup()
    return new Promise((resolve) => {
      axios.get('stops')
        .then(payload => {
          resolve(payload.data)
        })
    })
  },
  getGroupedTrips: (stopId) => {
    const axios = Axios.setup()
    return new Promise((resolve) => {
      axios.get('grouped_trips', { params: { stopId: stopId, tripCount: Constants.BUS_LOCATION_TRIP_COUNT } })
        .then(payload => {
          resolve(payload.data.groupedTrips)
        })
    })
  },
  getStopTime: (params) => {
    const axios = Axios.setup()
    return new Promise((resolve) => {
      axios.get('stop_time', { params: params })
        .then(payload => {
          resolve(payload.data)
        })
    })
  },
  getShapes: (tripId) => {
    const axios = Axios.setup()
    return new Promise((resolve) => {
      axios.get('shapes', { params: { tripId: tripId } })
        .then(payload => {
          resolve(payload.data)
        })
    })
  }
}
